import $ from "jquery";

export default function initStickyHeaderHelper() {
  const header = $('header.header');
  const wrapper = $('.wrapper');

  function scrollHandler() {
    const scrollTop = window.scrollY;


    if (scrollTop > 0) {
      header.addClass('position-fixed');
      wrapper.css({
        paddingTop: header.innerHeight()
      })
    } else {
      header.removeClass('position-fixed');
      wrapper.css({
        paddingTop: ''
      })
    }
  }
  scrollHandler();
  window.addEventListener('scroll', scrollHandler);
}